/**
 * Shared className for the small annotation tags used inside dense list rows —
 * household role tags, payment-card access tags, invite-status tags.
 *
 * Lives here rather than being retyped per card so the two cards stacked on
 * `/my-family` and `/billing` can't drift apart by a pixel.
 *
 * Pair it with a `Badge variant` that carries no `dark:` classes (`secondary`,
 * `outline`) when you also override the colors — a variant like `info` ships its
 * own `dark:text-*`, which twMerge treats as a different group from a plain
 * `text-*` override, so the override would win in light mode and lose in dark.
 *
 * `leading-none` is load-bearing: `Badge` sets no line-height, so a `text-[10px]`
 * label still reserves ~16px of inherited leading and the pill stays tall no
 * matter how small the type gets.
 */
export const COMPACT_TAG_CLASS = 'shrink-0 border-transparent px-1.5 py-[3px] text-[10px] font-medium leading-none'

/** Same tag, plus room for a leading icon. */
export const COMPACT_TAG_WITH_ICON_CLASS = `${COMPACT_TAG_CLASS} inline-flex items-center gap-1`
